/**
 * Schedule H1 of the Drugs Rules, 1945, inserted by G.S.R. 588(E) of 30
 * August 2013. A pharmacy records every supply of these medicines in a
 * separate register: the prescriber's name and address, the patient's name,
 * the medicine and the quantity supplied, kept for three years. The entries
 * cover the medicines and their salts and preparations.
 */
export const SCHEDULE_H1: readonly string[] = [
  'Alprazolam',
  'Balofloxacin',
  'Buprenorphine',
  'Capreomycin',
  'Cefdinir',
  'Cefditoren',
  'Cefepime',
  'Cefetamet',
  'Cefixime',
  'Cefoperazone',
  'Cefotaxime',
  'Cefpirome',
  'Cefpodoxime',
  'Ceftazidime',
  'Ceftibuten',
  'Ceftizoxime',
  'Ceftriaxone',
  'Chlordiazepoxide',
  'Clofazimine',
  'Codeine',
  'Cycloserine',
  'Diazepam',
  'Diphenoxylate',
  'Doripenem',
  'Ertapenem',
  'Ethambutol',
  'Ethionamide',
  'Feropenem',
  'Gemifloxacin',
  'Imipenem',
  'Isoniazid',
  'Levofloxacin',
  'Meropenem',
  'Midazolam',
  'Moxifloxacin',
  'Nitrazepam',
  'Pentazocine',
  'Prulifloxacin',
  'Pyrazinamide',
  'Rifabutin',
  'Rifampicin',
  'Sodium para-aminosalicylate',
  'Sparfloxacin',
  'Thiacetazone',
  'Tramadol',
  'Zolpidem',
];

/** Other spellings of Schedule H1 entries that medicine names use. */
const SPELLINGS: Readonly<Record<string, string>> = {
  faropenem: 'Feropenem',
  rifampin: 'Rifampicin',
  'para-aminosalicylate': 'Sodium para-aminosalicylate',
  'para-aminosalicylic': 'Sodium para-aminosalicylate',
  aminosalicylate: 'Sodium para-aminosalicylate',
  pas: 'Sodium para-aminosalicylate',
};

const WORD = /[a-z][a-z-]*/g;

/**
 * The Schedule H1 entry a medicine's name contains, such as Cefixime for
 * "Cefixime 200 mg tablet", or null. Combinations count when any part is on
 * the schedule. Names are matched word by word, so typed names work too.
 */
export function scheduleH1Entry(medicine: string): string | null {
  const words = medicine.toLowerCase().match(WORD) ?? [];
  for (const word of words) {
    const entry = SCHEDULE_H1.find((name) => name.toLowerCase() === word) ?? SPELLINGS[word];
    if (entry) return entry;
  }
  return null;
}
